// src/redux/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '../features/services/baseApi';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import cartDrawerReducer from '@/rtkQuery/features/services/cartDrawer/cartDrawerSlice';


export const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        cartDrawer: cartDrawerReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'persist/PERSIST',
                    'persist/REHYDRATE',
                ],
            },
        }).concat(baseApi.middleware),
    devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
